<template>
    <div
        @click="sendSmsCode"
        class="send-sms-btn"
    >
        {{ sendSmsBtnText }}
    </div>
</template>

<script>
// @Deprecation
import { helper } from '@x-tech/fe-puma-lib';
import * as authApi from '../../api/auth';

const regexHelper = helper.regex;
const COOL_DOWN_SECONDS = 60;

// 1 登录
// 2 重置密码
// 3 二次验证
export const SMS_CODE_TYPE_LOGIN = '1';
export const SMS_CODE_TYPE_RESET_PASSWORD = '2';
export const SMS_CODE_TYPE_SECOND_AUTH = '3';

export default {
    name: 'SendSmsCodeBtn',
    props: {
        username: {
            type: String,
            required: true
        },
        mobile: {
            type: String,
            required: true
        },
        captcha: {
            type: String,
            required: true
        },
        sessionId: {
            type: String,
            required: true
        },
        typ: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            sendSmsBtnText: '发送验证码'
        };
    },
    methods: {
        $_setSendSmsInCoolDown() {
            let time = COOL_DOWN_SECONDS;
            this.isSendSmsInCoolDown = true;

            clearInterval(this.sendSmsCoolDownTimer);
            this.sendSmsCoolDownTimer = setInterval(() => {
                if (time <= 0) {
                    this.isSendSmsInCoolDown = false;
                    this.sendSmsBtnText = '点击重新发送';
                } else {
                    this.sendSmsBtnText = `${time}秒`;
                    time -= 1;
                }
            }, 1000);
        },
        async sendSmsCode() {
            if (this.isSendSmsInCoolDown) {
                return;
            }

            if (this.typ !== SMS_CODE_TYPE_SECOND_AUTH) {
                if (!this.username) {
                    this.$message.warning('请输入有效用户名');
                    return;
                }
                if (!regexHelper.mobile.test(this.mobile)) {
                    this.$message.warning('请输入有效手机号');
                    return;
                }
            }
            if (!this.captcha) {
                this.$message.warning('请输入图形验证码');
                return;
            }

            try {
                await authApi.getSmsVerifyCode({
                    username: this.username,
                    phone: this.mobile,
                    code: this.captcha,
                    clientId: this.sessionId,
                    type: this.typ
                });
            } catch (e) {
                console.error(e);
                return;
            }

            this.$_setSendSmsInCoolDown();
            this.$message.success('验证码发送成功，请注意查收');
        }
    }
};
</script>

<style lang="scss" scoped>
.send-sms-btn {
  color: #b81b22;
  cursor: pointer;
}
</style>
